var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBulkActionBarDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bulk_action_bar_delete_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F9B3B3",
  d: "M11.166 6v6.667H5.833V6zm-1-4H6.833l-.667.667H3.833V4h9.333V2.667h-2.333zM12.5 4.667h-8v8C4.5 13.4 5.1 14 5.833 14h5.333c.734 0 1.334-.6 1.334-1.333z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bulk_action_bar_delete_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h16v16H.5z"
})))));
export default SvgBulkActionBarDelete;